export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const API_KEY = '73bee701-b3d1-4b42-937d-e6750fba4f3d';

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const MODEL_CLOSE_SEC = 2.5;
